/**
 * Route path constants
 * Centralized route definitions for type-safe navigation
 */
export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    DASHBOARD: '/dashboard',
    PROJECTS: '/projects',
    PROJECT_CREATE: '/projects/new',
    PROJECT_EDIT: '/projects/:id/edit',
    PROJECT_UPLOAD_RFP: '/projects/:id/upload-rfp',
    PROJECT_UPLOAD_VENDORS: '/projects/:id/upload-vendors',
    USERS: '/user',
    PROFILE: '/profile',
    SETTINGS: '/settings',
    SHOWCASE: '/showcase',
    DOCS: '/docs',
    UNAUTHORIZED: '/unauthorized',
    NOT_FOUND: '*',
    CONFIGURATION_LIST: '/configuration',
    CATEGORY_MANAGEMENT: '/configuration/category',
    TAG_MANAGEMENT: '/configuration/tag',
    SECTION_ANALYSIS: '/projects/:projectId/vendors/:vendorProposalId/section-analysis',
    SECTION_ANALYSIS_ALL: '/projects/:projectId/section-analysis',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = typeof ROUTES[RouteKey];
